// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IndexPage_wrapper__3Af1Y","outerWrapper":"IndexPage_outerWrapper__2eTFy"};